<template>
  <div class="beneficiary-form-container">
    <Panel title="3.รายละเอียดผู้รับผลประโยชน์">
      <div class="form-group">
        <div class="input-group">
          <div class="beneficiary-radio-container">
            <Radio
              name="beneficiaryType"
              label="heir"
              v-model="beneficiaryType"
              :disabled="disabledForm || !isValidatePayerSuccess"
            >
              ทายาทตามกฎหมาย
            </Radio>
          </div>
          <div class="beneficiary-radio-container">
            <Radio
              name="beneficiaryType"
              label="beneficiary"
              v-model="beneficiaryType"
              :disabled="disabledForm || !isValidatePayerSuccess"
            >
              ระบุผู้รับผลประโยชน์
            </Radio>
          </div>
        </div>
      </div>
      <div
        v-show-slide="beneficiaryType == 'beneficiary'"
        class="beneficiary-person-form-container row"
      >
        <div class="line line-dashed pull-in separator"></div>

        <div class="beneficiary-form clearfix">
          <div class="form-group col-sm-3">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                คำนำหน้าชื่อ
              </span>
              <Dropdown
                class="form-control input-sm"
                :options="namePrefixOptionsList"
                v-model="beneficiaryFirstPersonNamePrefix"
                :selectedValue="beneficiaryFirstPersonNamePrefix"
                :disabled="disabledForm || !isValidatePayerSuccess"
              />
            </div>
          </div>
          <div class="form-group col-sm-4">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">ชื่อ</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="beneficiaryFirstPersonFirstname"
                :disabled="disabledForm || !isValidatePayerSuccess"
              />
            </div>
          </div>
          <div class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">นามสกุล</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="beneficiaryFirstPersonLastname"
                :disabled="disabledForm || !isValidatePayerSuccess"
              />
            </div>
          </div>
        </div>

        <div class="beneficiary-form clearfix">
          <div class="form-group col-sm-3">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">
                คำนำหน้าชื่อ
              </span>
              <Dropdown
                class="form-control input-sm"
                :options="namePrefixOptionsList"
                v-model="beneficiarySecondPersonNamePrefix"
                :selectedValue="beneficiarySecondPersonNamePrefix"
                :disabled="disabledForm || !isValidatePayerSuccess"
              />
            </div>
          </div>
          <div class="form-group col-sm-4">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">ชื่อ</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="beneficiarySecondPersonFirstname"
                :disabled="disabledForm || !isValidatePayerSuccess"
              />
            </div>
          </div>
          <div class="form-group col-sm-5">
            <div class="input-group">
              <span class="input-group-addon nobd-nobg">นามสกุล</span>
              <input
                type="text"
                class="form-control input-sm"
                v-model="beneficiarySecondPersonLastname"
                :disabled="disabledForm || !isValidatePayerSuccess"
              />
            </div>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Dropdown from '@/components/Dropdown'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})

export default {
  name: 'BeneficiaryForm',
  props: ['typeInsurance', 'quotationId', 'disabledForm'],
  data() {
    return {
      namePrefixOptionsList: [],
    }
  },
  watch: {
    namePrefixList: {
      deep: true,
      handler(dataList) {
        const generateNamePrefixOptions = dataList.map(data => ({
          value: data.id,
          description: data.description,
        }))

        this.namePrefixOptionsList = [
          {
            value: '',
            description: '',
          },
          ...generateNamePrefixOptions,
        ]
      },
    },
  },
  computed: {
    ...mapGetters(['namePrefixList']),
    ...mapQuotationFields({
      isValidatePayerSuccess: 'payerInformation.data.isValidateInformationSuccess',
      beneficiaryType: 'beneficiary.type',
      beneficiaryFirstPersonNamePrefix: 'beneficiary.firstPerson.namePrefix',
      beneficiaryFirstPersonFirstname: 'beneficiary.firstPerson.firstname',
      beneficiaryFirstPersonLastname: 'beneficiary.firstPerson.lastname',
      beneficiarySecondPersonNamePrefix: 'beneficiary.secondPerson.namePrefix',
      beneficiarySecondPersonFirstname: 'beneficiary.secondPerson.firstname',
      beneficiarySecondPersonLastname: 'beneficiary.secondPerson.lastname',
    }),
  },
  components: {
    Dropdown,
    Panel,
    Radio,
  },
}
</script>

<style lang="scss">
.beneficiary-form-container {
  .beneficiary-radio-container {
    display: inline-block;
    margin-right: 32px;
  }

  .beneficiary-person-form-container {
    .separator {
      margin-bottom: 24px;
    }
  }
}
</style>
